module.exports = __webpack_public_path__ + "img/heart_20_bj.577f8ee1.png";